export type GlobalToastType = "error" | "success" | "info";

type GlobalToastHandler = (message: string, type: GlobalToastType) => void;

let globalToastHandler: GlobalToastHandler | null = null;

export const setGlobalToastHandler = (handler: GlobalToastHandler) => {
  globalToastHandler = handler;
};

export const notifyGlobalToast = (message: string, type: GlobalToastType) => {
  globalToastHandler?.(message, type);
};
